import { Languages } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

export default function LanguageSwitcher() {
  const { language, setLanguage } = useLanguage();

  return (
    <div className="fixed bottom-5 right-5 z-[120]">
      <div
        data-no-auto-translate="true"
        className="bg-white/95 backdrop-blur-md border border-slate-200 shadow-xl rounded-full p-1 flex items-center gap-1"
      >
        <button
          type="button"
          onClick={() => setLanguage('fr')}
          className={`flex items-center gap-2 px-3 py-2 rounded-full text-sm font-semibold transition-colors ${
            language === 'fr' ? 'bg-slate-900 text-white' : 'text-slate-700 hover:bg-slate-100'
          }`}
          aria-label="Passer le site en francais"
        >
          <span aria-hidden="true">🇫🇷</span>
          FR
        </button>
        <button
          type="button"
          onClick={() => setLanguage('en')}
          className={`flex items-center gap-2 px-3 py-2 rounded-full text-sm font-semibold transition-colors ${
            language === 'en' ? 'bg-slate-900 text-white' : 'text-slate-700 hover:bg-slate-100'
          }`}
          aria-label="Switch website to English"
        >
          <span aria-hidden="true">🇬🇧</span>
          EN
        </button>
        <span className="hidden sm:inline-flex items-center justify-center w-8 h-8 text-slate-400" aria-hidden="true">
          <Languages className="w-4 h-4" />
        </span>
      </div>
    </div>
  );
}
